export function locations() {
    $('.locations .btn-green').click(function () {
        gtag('event', 'Get Direction Click', {
            'event_category': 'Get Direction',
            'event_label': $(this).data('title'),
            'value': 1
        });
    });
}


// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/locations.js